export default [
  {
    path: "/analytics",
    name: "analytics",
    component: () => import("./pages/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
    },
  },
];
